// src/services/endpoints/organization.ts
export const organizationEndpoints = {
  getOrganizationProfile: '/private/v1/organization/profile',
  getOrganizationProfileById: (id: string) => `/private/v1/organization/${id}`,
  listOrganizationAdmins: '/private/v1/organization/admins',
  getOrganizationSeatSummary: '/private/v1/organization/seats',
  listOrganizationUsers: '/private/v1/organization/users',
} as const;
